/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import type { SVGProps } from 'react';

export type IllustrationSizeVariants =
  | 'small'
  | 'medium'
  | 'large'
  | 'xlarge'
  | 'xxlarge'
  | 'xxxlarge'
  | 'xxxxlarge';
export type IllustrationProps = {
  width?: number | string;
  height?: number | string;
  size?: IllustrationSizeVariants;
};
const IllustrationSpotCheck = ({
  size = 'medium',
  width,
  height,
  ...props
}: IllustrationProps) => {
  let presetWidth: string | undefined;
  let presetHeight: string | undefined;
  const presets = {
    small: '48px',
    medium: '68px',
    large: '92px',
    xlarge: '122px',
    xxlarge: '156px',
    xxxlarge: '194px',
    xxxxlarge: '236px',
  };
  if (size) {
    presetWidth = presets[size];
    presetHeight = presets[size];
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 68 68"
      data-xds="IllustrationSpotCheck"
      height={height || presetHeight}
      role="presentation"
      width={width || presetWidth}
      {...props}
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M61.452 32.972c0 15.729-12.751 28.48-28.48 28.48S4.49 48.7 4.49 32.972 17.24 4.49 32.97 4.49s28.48 12.752 28.48 28.48"
        clipRule="evenodd"
      />
      <path
        fill="var(--xdlColorIllustrationOutlinePrimary)"
        fillRule="evenodd"
        d="M32.972 3.49c11.38 0 21.253 6.45 26.167 15.891a28.35 28.35 0 0 1 5.37 16.648c0 15.73-12.75 28.48-28.48 28.48a28.35 28.35 0 0 1-16.647-5.369C9.939 54.226 3.491 44.352 3.491 32.972 3.49 16.69 16.69 3.49 32.97 3.49m0 2C17.794 5.49 5.49 17.796 5.49 32.973s12.303 27.48 27.48 27.48 27.48-12.304 27.48-27.48S48.149 5.49 32.972 5.49"
        clipRule="evenodd"
      />
      <path
        fill="#27DBA8"
        fillRule="evenodd"
        d="M16.899 28.649 32.19 44.103l29.578-33.826-5.355-5.451L31.7 33.554l-10.713-9.649z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default IllustrationSpotCheck;
